/**
 *   create by zhanghang
 */

import { memo } from 'react'
import { Route, Switch } from 'react-router-dom'
import asyncRouter from './router'
import { InterRouteConfig } from './router.d'
import Home from '@/layout/Home'
import StepNav from '@/layout/StepNav'
// import RouteGuard from '@/components/RouteGuard/RouteGuard'

function SubRoute(): JSX.Element | null {
  return (
    <Switch>
      <Home>
        {asyncRouter.map((item: InterRouteConfig) => {
          const WrappedComponent = item.components
          const hasStep = typeof item.step === 'number'
          const ComponentWithLayout = (props: any) => (
            <>
              {hasStep && <StepNav step={item.step} type={item.type} />}
              <WrappedComponent {...props} />
            </>
          )
          return typeof item.step === 'number' ? (
            <Route path={item.path} exact={item.exact} key={item.name} component={ComponentWithLayout} />
          ) : (
            <Route path={item.path} exact={item.exact} key={item.name} component={WrappedComponent} />
          )
        })}
      </Home>
    </Switch>
  )
}

export default memo(SubRoute)
